<template>
	<div class="faq-page">
		<!-- definePageMeta -->
		<Head>
			<Title>{{ pageMetaObject?.title ?? `${$t('components.nav.frequent_questions')} | CarFree` }}</Title>
			<Meta name="description" :content="pageMetaObject?.description ?? ''" />
			<Meta v-if="config.public.isIndex" name="robots" :content="robotsCalculated" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link rel="canonical" :href="pageMetaObject?.canonical && pageMetaObject?.canonical?.trim() ? pageMetaObject?.canonical : url.href" />
		</Head>

		<GlobalHeader />

		<div class="faq-page__container">
			<h1 class="faq-page__title">{{ $t('components.nav.frequent_questions') }}</h1>
			<FaqGroups v-if="faqGroups.length" :groups="faqGroups" />
			<FaqContactCard />
		</div>
	</div>
</template>

<script setup lang="ts">
import { ECMSType, ECMSPage, EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const config = useNuxtApp().$config
const url = useRequestURL()
const { locale } = useI18n()

const { data: pageSections } = await useAsyncData<IHomePageSectionModel[] | null>(`faq-page-sections-${locale.value}`, async () => {
	try {
		return (await ApiService.fetchPageSections(ECMSType.SUBPAGE, ECMSPage.FAQ, locale.value, { skipSSRPayload: true }))?.data ?? null
	} catch (error) {
		logger.log(error)
		return null
	}
})

const pageMetaObject = computed<{ [key: string]: string } | undefined>(
	() =>
		pageSections.value
			?.find((section) => section.name === EPageSectionType.META)
			?.translations.find((translation) => translation.language === locale.value)?.content[0],
)
const faqGroups = computed(
	() =>
		(pageSections.value
			?.find((section) => section.name === EPageSectionType.FAQ_GROUPS)
			?.translations.find((translation) => translation.language === locale.value)?.content ?? []) as unknown as IFaqGroup[],
)

const robotsCalculated = useRobotsMeta(() => pageMetaObject.value?.robots)

usePageViewed(EGTMPageType.FAQ)
</script>

<style lang="scss" scoped src="./index.scss"></style>
